export default "__VITE_ASSET__DULE$dZI__"